export default "__VITE_ASSET__CUGAnReF__"